export const images = {
    logoMega: "../images/megacable-logo2.svg",
    cards: "../images/tarjetas.png",
    loadingBlue: "../images/loading-blue.gif",
    soriana: "../images/sin-estado/soriana.png",
    chedraui: "../images/con-estado/ico-2.png",
    bancoppel: "../images/con-estado/ico-3.png",
    merza: "../images/con-estado/ico-4.png",
    lagunitas: "../images/con-estado/ico-5.png",
    alsuper: "../images/con-estado/ico-6.png",
    ley: "../images/con-estado/ico-7.png",
    bienestar: "../images/con-estado/ico-8.png",
    finanBienestar: "../images/sin-estado/ico-1.png",
    sevenEleven: "../images/sin-estado/ico-2.png",
    fBenavides: "../images/sin-estado/ico-3.png",
    walmart: "../images/sin-estado/ico-4.png",
    bAurrera: "../images/sin-estado/ico-5.png",
    suburbia: "../images/sin-estado/ico-6.png",
    six: "../images/sin-estado/ico-7.png",
    fDonde: "../images/sin-estado/ico-8.png",
    kiosko: "../images/sin-estado/ico-9.png",
    circleK: "../images/sin-estado/ico-10.png",
    waldos: "../images/sin-estado/ico-11.png",
    sams: "../images/sin-estado/ico-12.png",
    fasti: "../images/sin-estado/ico-13.png",
    superama: "../images/sin-estado/ico-14.png",
    mtc: "../images/sin-estado/ico-15.png",
    oxxo: "../images/sin-estado/ico-16.png",
    fZamora: "../images/sin-estado/ico-17.png",
    yastas: "../images/sin-estado/ico-18.png",
    quiubo: "../images/sin-estado/ico-19.png",
    sysTienda: "../images/sin-estado/ico-20.png",
    yomp: "../images/sin-estado/ico-21.png",
    yza: "../images/sin-estado/ico-22.png",
    farmaCon: "../images/sin-estado/ico-23.png",
    moderna: "../images/sin-estado/ico-24.png",
    generix: "../images/sin-estado/ico-25.png",
    cashi: "../images/sin-estado/cashi.png",
    fAhorro: "../images/sin-estado/ico-28.png",
    sanPablo: "../images/sin-estado/ico-29.png",
    deliSmart: "../images/sin-estado/ico-30.png",
    aramark: "../images/sin-estado/ico-31.png",
    pVenta: "../images/sin-estado/ico-32.png",
    dunosusa: "../images/sin-estado/ico-33.png",
    sanBorja: "../images/sin-estado/ico-34.png",
    neto: "../images/sin-estado/ico-35.png",
    tony: "../images/sin-estado/ico-36.png",
    ya: "../images/sin-estado/ico-37.png",
    pagaTodo: "../images/sin-estado/ico-38.png",
    suBodega: "../images/sin-estado/ico-40.png",
    wExpress: "../images/sin-estado/ico-41.png",
    goMart: "../images/sin-estado/ico-42.png",
    bankaool: "../images/sin-estado/ico-43.png",
    pRapido: "../images/sin-estado/ico-44.png",
    via: "../images/sin-estado/ico-45.png",
    paynom: "../images/sin-estado/ico-46.png",
    mavi: "../images/sin-estado/ico-47.png",
    asturiano: "../images/sin-estado/ico-48.png",
    netPay: "../images/sin-estado/ico-49.png",
    circleK2: "../images/sin-estado/ico-50.png",
    sFrancisco: "../images/sin-estado/ico-51.png",
    extra: "../images/sin-estado/ico-52.png",
    union: "../images/sin-estado/ico-53.png",
    fTodo: "../images/sin-estado/ico-54.png",
    vuala: "../images/sin-estado/ico-55.png",
    plata: "../images/sin-estado/ico-56.png",
    odessa: "../images/sin-estado/ico-57.png",
    liverpool: "../images/sin-estado/ico-58.png",
    mercadoPago: "../images/sin-estado/mercado-pago.png",
    liverpool2: "../images/sin-estado/liverpool.png",
    megaLogoMR: "../images/mega-logo-mr.png",
    bbb: "../images/sin-estado/ico-59.png",
    spin: "../images/sin-estado/ico-60.png",
    cimaco: "../images/con-estado/ico-9.png"
};